(function(){
    'use strict';

    angular.module('elogbooks.user.absence-planners', []);
})();